<template>
  <div
    class="group relative mx-2 my-0.5 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-200 overflow-hidden"
    :class="isActive
      ? 'bg-primary-50 text-primary-700 shadow-sm'
      : 'text-gray-700 hover:bg-gray-100 hover:shadow-sm'"
  >
    <!-- Active indicator bar -->
    <div
      v-if="isActive"
      class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-primary-600 rounded-r-full transition-all duration-200"
    />

    <!-- Content -->
    <div class="relative flex items-center gap-3  text-[12px] leading-tight">
      <slot />
    </div>

    <!-- Subtle hover effect -->
    <div
      class="absolute inset-0 bg-gradient-to-r from-transparent to-primary-50/0 group-hover:to-primary-50/30 transition-all duration-300 pointer-events-none"
      :class="{ 'opacity-0': isActive }"
    />
  </div>
</template>

<script setup lang="ts">
const isActive = defineModel<boolean>('isActive', {
  required: true,
  default: false,
})
</script>
